export const APP_IMAGE = {
  "Image.Box.Sizing": {
    defaultValue: "border-box"
  },
  "Image.Bg.Color": {
    defaultValue: "transparent"
  },
  "Image.Width": {
    defaultValue: "300px"
  },
  "Image.Height": {
    defaultValue: "300px"
  },
  "Image.Min.Width": {
    defaultValue: "0"
  },
  "Image.Min.Height": {
    defaultValue: "0"
  },
  "Image.Max.Width": {
    defaultValue: "unset"
  },
  "Image.Max.Height": {
    defaultValue: "unset"
  },
  "Image.Opacity": {
    defaultValue: "1"
  },
  "Image.Shadow": {
    defaultValue: "none"
  },
  "Image.Margin.Top": {
    defaultValue: "0"
  },
  "Image.Margin.Right": {
    defaultValue: "0"
  },
  "Image.Margin.Bottom": {
    defaultValue: "0"
  },
  "Image.Margin.Left": {
    defaultValue: "0"
  },
  "Image.Border.Style": {
    defaultValue: "solid"
  },
  "Image.Border.Color": {
    defaultValue: "transparent"
  },
  "Image.Border.Top.Width": {
    defaultValue: "0"
  },
  "Image.Border.Right.Width": {
    defaultValue: "0"
  },
  "Image.Border.Bottom.Width": {
    defaultValue: "0"
  },
  "Image.Border.Left.Width": {
    defaultValue: "0"
  },
  "Image.Padding.Top": {
    defaultValue: "0"
  },
  "Image.Padding.Right": {
    defaultValue: "0"
  },
  "Image.Padding.Bottom": {
    defaultValue: "0"
  },
  "Image.Padding.Left": {
    defaultValue: "0"
  },
  "Image.Border.Top.Right.Radius": {
    defaultValue: "0"
  },
  "Image.Border.Bottom.Right.Radius": {
    defaultValue: "0"
  },
  "Image.Border.Bottom.Left.Radius": {
    defaultValue: "0"
  },
  "Image.Border.Top.Left.Radius": {
    defaultValue: "0"
  },
  "Image.Hover.Opacity": {
    defaultValue: "1"
  },
  "Image.Hover.Shadow": {
    defaultValue: "none"
  },
  "Image.Hover.Bg.Color": {
    defaultValue: "transparent"
  },
  "Image.Hover.Border.Color": {
    defaultValue: "transparent"
  },
  "Image.Hover.Border.Style": {
    defaultValue: "solid"
  },
  "Image.Hover.Border.Top.Width": {
    defaultValue: "0"
  },
  "Image.Hover.Border.Right.Width": {
    defaultValue: "0"
  },
  "Image.Hover.Border.Bottom.Width": {
    defaultValue: "0"
  },
  "Image.Hover.Border.Left.Width": {
    defaultValue: "0"
  },
  "Image.Object.Fit": {
    defaultValue: "contain"
  },
  "Image.Fill.Type": {
    ref: "Image.Object.Fit"
  }
};
